import { css } from "@emotion/react";

export const teamMembers = css`
  padding-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  max-width: 75rem;
  margin-left: auto;
  margin-right: auto;
`;

export const teamMember = css`
  @media only screen and (min-width: 64.063em) {
    padding: 25px 50px;
  }

  @media only screen and (max-width: 40em) {
    padding: 20px 0;
  }

  @media only screen and (min-width: 40.063em) and (max-width: 64em) {
    padding: 20px;
  }
`;

export const info = css`
  color: #222;
  padding: 20px 0;
  text-align: center;
  min-height: 152px; /* for names that take 2 lines */
`;

export const name = css`
  margin: 0;
  font-size: 1.5em;
`;

export const infoList = css`
  list-style-type: none;
  margin: 0;

  & li {
    font-size: 0.9em;
  }
`;
